<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ProjProgressOldCol',
})
</script>
<template>
  <Status :type="currentType" style="cursor: pointer" @click="visible = true">
    {{ current.name }}
  </Status>

  <Drawer v-model:visible="visible" width="400px" :title="title" placement="right" :class="bem()">
    <Steps direction="vertical">
      <Steps.Step
        v-for="(item, index) in steps"
        :key="`${item.name}-${index}`"
        :title="item.name"
        :subTitle="getStatusText(item.status)"
        :status="getStepStatus(item.status)"
        @click="$emit('navigate', item)"
      />
    </Steps>
  </Drawer>
</template>

<script lang="ts" setup name="ProjProgressOldCol">
import { computed, ref } from 'vue'
import { Drawer, Steps } from 'ant-design-vue'
import { createNamespace } from '@bd/vue3-utils'
import { Status } from '-/Common/Status'
const [, bem] = createNamespace('ProjProgressOldCol')
const props = withDefaults(
  defineProps<{
    current: ProjOldStatus
    steps: ProjOldStatus[]
    name?: string
  }>(),
  {
    steps: () => []
  }
)
defineEmits(['navigate'])
const visible = ref(false)

type ProjOldStatusValue = ProjOldStatus['status']

const title = computed(() => (props.name ? `${props.name} - 项目状态` : '项目状态'))

function getStatusType(status: ProjOldStatusValue) {
  return status === null ? 'warning' : status ? 'success' : 'processing'
}

function getStatusText(status: ProjOldStatusValue) {
  return status === null ? '未开始' : status ? '已完成' : '进行中'
}

function getStepStatus(status: ProjOldStatusValue) {
  return status === null ? 'wait' : status ? 'finish' : 'process'
}

const currentType = computed(() => getStatusType(props.current.status))
</script>

<style lang="less">
.proj-progress-old-col {
  .ant-steps-item-finish .ant-steps-item-icon {
    border-color: @success-color !important;

    .ant-steps-icon {
      color: @success-color !important;
    }
  }
}
</style>
